import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-property-detail',
  templateUrl: './property-detail.component.html',
  styleUrls: ['./property-detail.component.css']
})
export class PropertyDetailComponent implements OnInit {

  propertyDetailsPage = true;

  prop_service_id = '';
  prop_id = '';
  modelData: any = {};
  ulb_data: any = [];
  property_detail: any = [];
  selectAll = false;

  property_id: any;
  billData: any = {};
  is_partial_payment = false;
  amount = 0;
  redirection_payment = null;
  selectedRowIndex = 0;

  constructor(private apiService: ApiService,
    private activatedRoute: ActivatedRoute, 
    private appComponent: AppComponent) { }

  ngOnInit(): void {
    console.log(this.activatedRoute);
    
    this.prop_service_id = this.activatedRoute.snapshot.queryParams['property_id'];
    // this.prop_id = this.activatedRoute.snapshot.params['id'];
    this.activatedRoute.queryParams
      .subscribe(params => {
        this.redirection_payment = params['payment'];
      }
    );
    this.getSearviceNumberList();
  }

  getSearviceNumberList() {
    this.appComponent.showLoader();
      this.apiService.get(`get_property?property_id=${this.prop_service_id}`).subscribe(
        (res: any) => {
          this.property_detail = res['data'];
          // this.property_detail.services.forEach((val: any)=>{
          //     this.amount += parseFloat(val.payable_total_amount);
          // });
          this.amount = parseFloat(this.property_detail.services[0].payable_total_amount);

          this.appComponent.hideLoader();
        },
        (error) =>{
          this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
          this.appComponent.hideLoader();
        })
  }

  onSelectAllChange() {
    if (this.selectAll) {
      this.property_detail.services.map((val: any) => val.ischecked = true);
    } else {
      this.property_detail.services.map((val: any) => val.ischecked = false);
    }
  }

  onClickPay(){
    // this.propertyDetailsPage = false;
    this.makePayment();
  }

  // onPartialPaymentChange() {
  //   console.log(this.is_partial_payment)
  //   if (this.is_partial_payment) {
  //     this.amount = this.billData.bill.amount;
  //   } else {
  //     this.amount = this.billData.bill.payable_amount;
  //   }
  // }

  makePayment() {
  
    if(this.property_detail.services.length <= 1){
      this.property_detail.services[0].ischecked = true;
    };
    
    let properties: any = [];
    // this.property_detail.services.forEach((val: any)=>{
    //   if(val.ischecked){
    //      properties.push({
    //         "service_type_id": val.service_type_id,
    //         "property_id": val.property_id
    //     });
    //     this.amount += parseFloat(val.payable_total_amount);
    //     }
    // });
    
    let _property  = this.property_detail?.services[this.selectedRowIndex];
    properties.push({
              "service_type_id": _property.service_type_id,
              "property_id": _property.property_id
          });

    let formData = {
      payment_gateway_id: 1,
      amount: this.amount,
      is_partial_payment: this.is_partial_payment,
      consumer_detail_id: this.property_detail.consumer_id,
      "properties": properties
    }


    this.apiService.post(`make_payment`, formData).subscribe(
      (res: any) => {
        const product = res.data;

        const paymentDetails = {
          payu_url: product.payu_url,
          first_name: product.first_name,
          email: product.email,
          mobile: product.mobile,
          callback_url: product.call_back_url,
          payu_cancel_url: product.payu_cancel_url,
          payu_fail_url: product.payu_fail_url,
          payu_merchant_key: product.payu_merchant_key,
          payu_sha_token: product.payu_sha_token,
          txnid: product.txnId,
          plan_name: product.plan_name,
          amount: product.amount,
          service_provider: product.service_provide
        };

        let paymentString = `
          <html>
            <body>
              <form action="${paymentDetails.payu_url}" method="post" id="payu_form">
                <input type="hidden" name="firstname" value="${paymentDetails.first_name}"/>
                <input type="hidden" name="email" value="${paymentDetails.email}"/>
                <input type="hidden" name="phone" value="${paymentDetails.mobile}"/>
                <input type="hidden" name="surl" value="${paymentDetails.callback_url}"/>
                <input type="hidden" name="curl" value="${paymentDetails.payu_cancel_url}"/>
                <input type="hidden" name="furl" value="${paymentDetails.payu_fail_url}"/>
                <input type="hidden" name="key" value="${paymentDetails.payu_merchant_key}"/>
                <input type="hidden" name="hash" value="${paymentDetails.payu_sha_token}"/>
                <input type="hidden" name="txnid" value="${paymentDetails.txnid}"/>
                <input type="hidden" name="productinfo" value="${paymentDetails.plan_name}"/>
                <input type="hidden" name="amount" value="${paymentDetails.amount}"/>
                <input type="hidden" name="service_provider" value="${paymentDetails.service_provider}"/>
                <button type="submit" value="submit" #submitBtn></button>
              </form>
              <script type="text/javascript">document.getElementById("payu_form").submit();</script>
            </body>
          </html>`;

        const winUrl = URL.createObjectURL(
          new Blob([paymentString], { type: "text/html" })
        );

        window.location.href = winUrl;
      },
      (error) =>{
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      })
  }


}



